import { getWMSCapabilities, actionAddLayers, actionSetLayerOpacity, actionSetLayerVisibility, } from '@tmapy/mapcore';
import { PANEL } from '@tmapy/config';
import { actionSetPanel } from '@tmapy/ui-manager';
import { SET_LAYER_SWITCHER_STATE, LAYER_SWITCHER_GROUP_TOGGLE, LAYER_SWITCHER_SET_FILTER, LAYER_SWITCHER_GROUP_VISIBILITY, ADD_LAYER_SWITCHER_LAYERS, } from './constants';
import { deriveLayerSwitcherStateFromCapabilities } from './utils/deriveLayerSwitcherStateFromCapabilities';
import { getLayer } from './utils/getLayer';
export const actionDeactivateLayerSwitcher = () => (dispatch) => {
    dispatch(actionSetPanel(PANEL.NONE));
};
export const actionSetLayerSwitcherState = (payload) => ({
    type: SET_LAYER_SWITCHER_STATE,
    payload,
});
export const actionLoadCustomLayers = () => async (dispatch, getState) => {
    const state = getState();
    const { extLayers } = state.router.hashParams;
    if (!extLayers)
        return;
    const services = extLayers.split('*');
    return await Promise.all(services.map((service, idx) => dispatch(actionAddLayersByURL(service, `_${idx}`))));
};
export const actionLayerSwitcherGroupToggle = (payload) => ({
    type: LAYER_SWITCHER_GROUP_TOGGLE,
    payload,
});
export const actionLayerSetFilter = (payload) => ({
    type: LAYER_SWITCHER_SET_FILTER,
    payload,
});
export const actionSaveGroupVisibility = (payload) => ({
    type: LAYER_SWITCHER_GROUP_VISIBILITY,
    payload,
});
export const actionAddLayerSwitcherLayers = (payload) => ({
    type: ADD_LAYER_SWITCHER_LAYERS,
    payload,
});
export const actionAddLayersByURL = (addServiceUrl, idPrefix) => async (dispatch) => {
    const capabilities = await getWMSCapabilities(addServiceUrl);
    if (!capabilities)
        return;
    const addedLayers = [];
    const layerState = deriveLayerSwitcherStateFromCapabilities(capabilities.Capability.Layer, idPrefix, addedLayers);
    dispatch(actionAddLayers(addedLayers.map((layer) => {
        return {
            ...layer,
            sourceOptions: { ...layer.sourceOptions, url: addServiceUrl },
        };
    })));
    dispatch(actionAddLayerSwitcherLayers([layerState]));
};
export const actionMakeLayersVisible = (layerIds) => (dispatch, getState) => {
    const state = getState();
    const mapLayers = state.mapCore.layers;
    const layerSwitcher = state.layerSwitcher;
    const visibilityByLayerIds = {};
    const opacityByLayerIds = {};
    layerIds.forEach((layerId) => {
        const { exclusiveLayerIds } = getLayer(layerId, layerSwitcher);
        const mapLayer = mapLayers.find((mapLayer) => mapLayer.id === layerId);
        const opacity = mapLayer?.layerOptions.opacity;
        if (!opacity) {
            opacityByLayerIds[layerId] = 1;
        }
        if (exclusiveLayerIds) {
            exclusiveLayerIds.forEach((exclusiveLayerId) => (visibilityByLayerIds[exclusiveLayerId] = false));
        }
        visibilityByLayerIds[layerId] = true;
    });
    if (Object.keys(opacityByLayerIds).length > 0) {
        dispatch(actionSetLayerOpacity(opacityByLayerIds));
    }
    dispatch(actionSetLayerVisibility(visibilityByLayerIds));
};
//# sourceMappingURL=actions.js.map